import React, { FunctionComponent, useState } from "react";
import styles from "./styles.module.scss";
import { Box, DialogActions, DialogContent, Toolbar, useTheme } from "@mui/material";
import { Counter } from "../../Counter";
import { ContainedButton } from "../../ContainedButton";
import { strings } from "../../../localization/LocalizedStrings";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { PiperDialog } from "../../PiperDialog";
import { IconType } from "../../../icons";

export const ModifyIncrementalAttributeDialog: FunctionComponent<
  IModifyIncrementalAttributeDialogProps
> = ({ title, description, canClear, open, setOpen, value, maxValue, onChange }) => {
  const theme = useTheme();
  const [incrementalNumber, setIncrementalNumber] = useState<number | null>(value ?? 1);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <PiperDialog fullWidth maxWidth={"xs"} open={open} onClose={handleClose}>
      <Toolbar>
        <h3>{title}</h3>
        <Box flexGrow={1} />
        {canClear && (
          <ToolbarButton
            onClick={() => {
              onChange(null);
              handleClose();
            }}
            tooltip={strings.clear_value}
            iconType={IconType.DeleteForever}
            color={theme.palette.colors?.remove}
          />
        )}
        <ToolbarButton onClick={handleClose} tooltip={strings.close} iconType={IconType.Close} />
      </Toolbar>
      <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
        <p className={styles.description}>{description}</p>
        <Counter
          className={styles.counter}
          initialValue={value ?? 1}
          minimumValue={1}
          maximumValue={maxValue}
          nullable={canClear}
          onValueChanged={newValue => setIncrementalNumber(newValue)}
        />
      </DialogContent>
      <DialogActions>
        <ContainedButton
          type={"submit"}
          onClick={() => {
            onChange(incrementalNumber);
            handleClose();
          }}
        >
          {strings.alert_confirm}
        </ContainedButton>
      </DialogActions>
    </PiperDialog>
  );
};

export interface IModifyIncrementalAttributeDialogProps {
  title: string;
  description: string;
  canClear: boolean;
  open: boolean;
  setOpen: (state: boolean) => void;
  value: number | undefined;
  maxValue?: number;
  onChange: (newValue: number | null) => void;
}
